import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: 'walletIdTruncate',
})
export class WalletIdTruncatePipe implements PipeTransform {
  transform(id?: string | null): string {
    if (id) {
      const first = id.slice(0, 6);
      const last = id.slice(id.length - 4);
      return `${first}...${last}`;
    }
    return '';
  }
}
